import { LinearProgress, styled } from '@mui/material';

export const ProgressIndicatorStyled = styled(LinearProgress)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
`;
